import React, { useEffect, useState }from "react";
import useCeo from "../../hooks/useCEO";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";
import "react-datepicker/dist/react-datepicker.css";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import "datatables.net-responsive/js/dataTables.responsive.min.mjs";
import $ from "jquery";
import { useUnidades } from "../../hooks/test/useUnidades";

  export const ReporteProductividad = () => {

    useCeo({
        title: "Productivity report",
        description: "Página de productivity",
    });

    const [startDate, setStartDate] = useState(new Date());
    const [formInfo, setFormInfo] = useState({
      fechaInicial: new Date(),
      fechaFinal: new Date(),
    });
    const [reportMonitorista, setReportMonitorista] = useState([{
        name : "",
        mnsActivo : "",
        porcentajeActivo : "",
        mnsComida : "",
        porcentajeComida : "",
        mnsDescanso : "",
        porcentajeDescanso : "",
        otroEvento : "",
        porcentajeOtroEvento : "",
        totalMinutos : "",
        porcentajetotalHoras : "",
        fechaInicio : "",
        fechaFin : "",
    }]);

    const componentDidMount = () =>{
      if (!$.fn.DataTable.isDataTable("#myTable")) {
                  $(document).ready(function () {
                    setTimeout(function () {
                      $("#table").DataTable({
                        pagingType: "full_numbers",
                        pageLength: 5,
                        processing: true,
                        responsive: true,
                        dom: "Bfrtip",
                        select: {
                          style: "single",
                        },
                        language: {
                          info : "Mostrando _START_ de _TOTAL_ registros",
                          infoFiltered : '(filtrado de _MAX_ registros totales)',
                          search: "Buscar:",
                          paginate: {
                                first: "Primero",
                                last: "Último",
                                next: "Siguiente",
                                previous: "Anterior",
                            },
                        },

            
                        buttons: [
                      //    {
                      //      extend: "pageLength",
                      //      className: "btn btn-secondary bg-secondary",
                      //    },
                      //    {
                      //      extend: "copy",
                      //      className: "btn btn-secondary bg-secondary",
                      //    },
                      //    {
                      //      extend: "csv",
                      //      className: "btn btn-secondary bg-secondary",
                      //    },
                          {
                              extend: "csv",
                              text:  "Export CSV",
                              className: "btn btn-secondary bg-secondary"
                          },
                          // {
                          //     extend: "xls",
                          //     className: "btn btn-secondary bg-secondary",
                          // },
                          // {
                          //     extend: "pdf",
                          //     text:  "Export PDF",
                          //     className: "btn btn-secondary bg-secondary",
                          // },
                      //    {
                      //      extend: "print",
                      //      customize: function (win) {
                      //        $(win.document.body).css("font-size", "10px");
                      //        $(win.document.body)
                      //          .find("table")
                      //          .addClass("compact")
                      //          .css("font-size", "inherit");
                      //      },
                      //      className: "btn btn-secondary bg-secondary",
                      //    },
                        ],
            
                        fnRowCallback: function (
                          nRow,
                          aData,
                          iDisplayIndex,
                          iDisplayIndexFull
                        ) {
                          var index = iDisplayIndexFull + 1;
                          $("td:first", nRow).html(index);
                          return nRow;
                        },
            
                        lengthMenu: [
                          [10, 20, 30, 50, -1],
                          [10, 20, 30, 50, "All"],
                        ],
                        columnDefs: [
                          {
                            targets: 0,
                            render: function (data, type, row, meta) {
                              return type === "export" ? meta.row + 1 : data;
                            },
                          },
                        ],
                      });
                    }, 1000);
                  });
                }
    } 

    useEffect(() => {
        componentDidMount(); 
    }, []);

    const {
      postReporteMonitoristas
    } = useUnidades();

    function minutesToString(seconds) {
      var hour = Math.floor(seconds / 3600);
      hour = (hour < 10)? '0' + hour : hour;
      var minute = Math.floor((seconds / 60) % 60);
      minute = (minute < 10)? '0' + minute : minute;
      var second = seconds % 60;
      second = (second < 10)? '0' + second : second;
      // return hour + ':' + minute + ':' + second;
      return hour + ':' + minute;
    }
       
    function showTable () {
        try {
            return reportMonitorista.map((item, index) => {

              let timeZone = "America/Mexico_City";
              let dateObjectfechaInicio = new Date(item.fechaInicio).toLocaleString("es-MX", {
                timeZone,
              });
              let dateObjectfechaFin = new Date(item.fechaFin).toLocaleString("es-MX", {
                timeZone,
              });

            return (
                <tr key={index}>
                    <td className="text-xs font-weight-bold">{index +1}</td>
                    <td className="text-xs font-weight-bold" style={ { fontSize: "12px" } }>
                      {
                        item.fechaInicio ?
                        dateObjectfechaInicio.localeCompare(dateObjectfechaFin) === 0 ? dateObjectfechaInicio :
                        dateObjectfechaInicio +" / "+dateObjectfechaFin
                        :
                        ""
                      }
                    </td>
                    <td className="text-xs font-weight-bold">{item.name}</td>
                    <td className="text-xs font-weight-bold">{minutesToString(item.mnsActivo * 60)}</td>
                    <td className="text-xs font-weight-bold">{item.porcentajeActivo}</td>
                    <td className="text-xs font-weight-bold">{minutesToString(item.mnsComida * 60)}</td>
                    <td className="text-xs font-weight-bold">{item.porcentajeComida}</td>
                    <td className="text-xs font-weight-bold">{minutesToString(item.mnsDescanso * 60)}</td>
                    <td className="text-xs font-weight-bold">{item.porcentajeDescanso}</td>
                    <td className="text-xs font-weight-bold">{minutesToString(item.otroEvento * 60)}</td>
                    <td className="text-xs font-weight-bold">{item.porcentajeOtroEvento}</td>
                    <td className="text-xs font-weight-bold">{minutesToString(item.totalMinutos * 60)}</td>
                </tr>
                );
            });
        } catch (e) {
        //  alert(e.message);
        }
    };

    const generarReporte = async() =>{
      if( formInfo && formInfo.fechaInicial !== "" && formInfo.fechaFinal !== ""){

        let initialDate = new Date(formInfo.fechaInicial);
        let finalDate = new Date(formInfo.fechaFinal);
        let mesInitialDate = initialDate.getMonth()+1;
        let diaInitialDate = initialDate.getDate();
        let mesFinalDate = finalDate.getMonth()+1;
        let diaFinalDate = finalDate.getDate();

        if(mesInitialDate < 10){
          mesInitialDate = "0"+mesInitialDate;
        }
        if(mesFinalDate < 10){
          mesFinalDate = "0"+mesFinalDate;
        }

        if(diaInitialDate < 10){
          diaInitialDate = "0"+diaInitialDate;
        }
        if(diaFinalDate < 10){
          diaFinalDate = "0"+diaFinalDate;
        }

        let initialDateFormat = initialDate.getFullYear() + "-" + mesInitialDate + "-" + diaInitialDate;
        let finalDateFormat = finalDate.getFullYear() + "-" + mesFinalDate + "-" + diaFinalDate;

        // console.log(initialDateFormat);
        // console.log(finalDateFormat);
        
        const reporteMonitoristas = await postReporteMonitoristas({
          "fecha_inicio": initialDateFormat,
	        "fecha_fin": finalDateFormat
        });

        $('#table').DataTable().destroy();
        if(reporteMonitoristas.ok){
          componentDidMount();
          Swal.fire({
            title: "OK",
            text: "Reporte Generado",
            icon: "success"
          });
          setReportMonitorista(reporteMonitoristas.indicadores)
        }else{
          Swal.fire({
            title: "Reporte",
            text: reporteMonitoristas.msg,
            icon: "warning"
          });
        }

      }else{
        Swal.fire({
          title: "Error",
          text: "Es necesario elegir una fecha",
          icon: "error"
        });
      }
    }

    return (
        <>
            <div className="container">
                <div className="row">
                  <div className="col-12" style={ {padding: "0 0 10px"}}>
                        <h2>REPORTE DE PRODUCTIVIDAD</h2>
                  </div>
                  <div className="col-4">
                      <label className="form-label">FECHA INICIAL</label>
                      <input 
                        type="date"
                        data-date-format="DD MMMM YYYY"
                        className="form-control" 
                        value={formInfo.fechaInicial} 
                        onChange={(date) => setFormInfo({...formInfo, fechaInicial: date.target.value})} 
                        // date.getFullYear()+'-',date.get
                      />
                  </div>
                  <div className="col-4">
                      <label className="form-label">FECHA FINAL</label>
                      <input 
                        type="date"
                        data-date-format="DD MMMM YYYY"
                        className="form-control" 
                        selected={formInfo.fechaFinal} 
                        onChange={(date) => setFormInfo({...formInfo, fechaFinal: date.target.value})}
                      />
                  </div>
                  <div className="col-4">
                      <button 
                        type="button" 
                        className="btn btn-primary" 
                        style={ { top: "30px", position: "relative" } }
                        onClick={ generarReporte }
                      >Generar reporte
                      </button>
                  </div>
                   
                  <div className="col-12">
                          <div className="table-responsive p-0 pb-2 pt-3" style={ { fontSize: "14px" } }>
                              <table id="table" className="table align-items-center justify-content-center mb-0">
                                  <thead>
                                      <tr>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">N°</th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Fecha</th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Monitorista</th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Activo <p style={ { fontSize: "11px", margin: 0 } }>[HH:MM]</p></th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Activo [%]</th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Comida <p style={ { fontSize: "11px", margin: 0 } }>[HH:MM]</p></th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Comida [%]</th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Descanso <p style={ { fontSize: "11px", margin: 0 } }>[HH:MM]</p></th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Descanso [%]</th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">otro evento <p style={ { fontSize: "11px", margin: 0 } }>[HH:MM]</p></th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">otro evento [%]</th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Total <p style={ { fontSize: "11px", margin: 0 } }>[HH:MM]</p></th>
                                      </tr>
                                  </thead>

                                  <tbody>
                                      { showTable()}
                                  </tbody>
                              </table>
                          </div>
                  </div>
                </div>
            </div>
        </>
    );
}
